module.exports = __webpack_public_path__ + "static/usattalladega-fe0f88600547d9df7ccdc5b340147ca2.jpg";